import { DayOfWeek, Instant } from "./JSJodaJSON";
import { CaregiverId, PlanOfCareId, PlanOfCareItemId } from "./ObjectIds";
import { PatientDocumentContentItem } from "./PatientDocuments";

// region RN
export interface POCItem {
  id: PlanOfCareItemId;
  label: string;
  section: string;
  code: string;
  type: POCAnswerType;
  orderInSection: number;
}

export enum pocItemTypes {
  Section = "bigHeader",
  Attribute = "smallHeader",
  Task = "check",
}

export interface POCItemsList {
  questions: POCItem[];
}

export type POCItemAnswer = POCItemAnswer.Task | POCItemAnswer.Attribute;

export const pocAnswerType = {
  Task: "Task",
  Attribute: "Attribute",
  Predefined: "Predefined",
};

export type POCAnswerType = keyof typeof pocAnswerType;

export declare namespace POCItemAnswer {
  export interface Task {
    readonly type: "Task";
    notes: string | null;
    whenToPerform: TaskWhenToPerform;
  }

  export interface Attribute {
    readonly type: "Attribute";
    notes: string | null;
  }
}

export const taskWhenToPerformType = {
  EveryVisit: "EveryVisit",
  OnDaysOfWeek: "OnDaysOfWeek",
  AsRequestedByPatient: "AsRequestedByPatient",
};
export type TaskWhenToPerformType = keyof typeof taskWhenToPerformType;

export type TaskWhenToPerform =
  | TaskWhenToPerform.EveryVisit
  | TaskWhenToPerform.OnDaysOfWeek
  | TaskWhenToPerform.AsRequestedByPatient;

export declare namespace TaskWhenToPerform {
  export interface EveryVisit {
    type: "EveryVisit";
  }

  export interface OnDaysOfWeek {
    type: "OnDaysOfWeek";
    frequency?: FrequencyVisitedInAWeekDetails;
    days?: DayOfWeek[];
  }

  export interface AsRequestedByPatient {
    type: "AsRequestedByPatient";
  }
}

export interface FrequencyVisitedInAWeekDetails {
  frequency: number | null;
  visitsInAWeek: number | null;
}

export interface POCItemAnswerResponse {
  success: boolean;
}

export interface POCSignature {
  type: "Caregiver" | "Patient";
  data: string | null;
  unsignedReason?: string | null;
}

// endregion

// region caregiver
export interface PlanOfCareCreationResponse {
  id: PlanOfCareId | null;
}

export interface PlanOfCareSignature {
  data: string;
  signedAt: Instant;
  unsignedResaon?: string | null;
}

export interface PlanOfCare {
  id: PlanOfCareId;
  createdAt: Instant;
  createdBy: CaregiverId;
  patientSignature: PlanOfCareSignature | null;
  patientUnsignedReason?: string | null;
  caregiverSignature: PlanOfCareSignature | null;
  submittedAt: Instant | null;
}

export interface PlanOfCareWithAnswers {
  poc: PlanOfCare;
  planOfCareType: {
    showPatientSignature: boolean;
  };
  docItems: PatientDocumentContentItem[];
  planOfCareItems: POCItem[];
  patientUnsignedReason?: string | null;
}

export interface PlanOfCareItemWithAnswer {
  item: POCItem;
  answer: POCItemAnswer | null;
}

export interface PlanOfCareResponse {
  planOfCareWithAnswers: PlanOfCareWithAnswers | null;
}

export interface DutySheetItem {
  item: POCItem;
  asRequestedByPatient: boolean;
  notes: string | null;
  completed: DutySheetItemAnswer | null;
}

export interface DutySheetListForDay {
  list: DutySheetItem[] | null;
}

export interface DutySheetItemAnswer {
  notes: string | null;
}

// export interface DutySheetSignatureAnswer {
//     data: string | null;
// }

// endregion
